import { render, staticRenderFns } from "./NotificationAdminConfig.vue.js?vue&type=template&id=4c61dc78!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotificationAdminConfig.vue?vue&type=template&id=4c61dc78"
import script from "./NotificationAdminConfig.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotificationAdminConfig.vue?vue&type=script&lang=js"
export * from "./NotificationAdminConfig.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotificationAdminConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports